import { cva } from 'class-variance-authority';

import { DocIcon, PdfIcon, PptIcon, XlsIcon } from '@/assets/icons';

export const FILE_GROUPS = {
  ppt: { ext: ['ppt', 'pptx'], component: PptIcon },
  doc: { ext: ['doc', 'docx'], component: DocIcon },
  xls: { ext: ['xls', 'xlsx', 'csv'], component: XlsIcon },
  pdf: { ext: ['pdf'], component: PdfIcon },
};

export const FILE_ITEM_VARIANTS = cva(
  // Padding is calculated as realPadding - borderWidth, ensuring consistent spacing inside the chatbox.
  'p-[calc(12px-1px)] flex gap-2 rounded-xs items-center max-w-full',
  {
    variants: {
      variant: {
        default:
          '[&_[data-slot=file-item-icon]]:size-6 [&_[data-slot=file-item-name]]:text-body-base [&_[data-slot=file-item-skeleton]]:h-2 [&_[data-slot=file-item-clear]]:size-5',
        sm: '[&_[data-slot=file-item-icon]]:size-5 [&_[data-slot=file-item-name]]:text-body-sm [&_[data-slot=file-item-skeleton]]:h-1.5 [&_[data-slot=file-item-loading]]:py-px [&_[data-slot=file-item-clear]]:size-5',
        xs: 'p-[calc(8px-1px)] [&_[data-slot=file-item-icon]]:size-4 [&_[data-slot=file-item-name]]:text-body-xs [&_[data-slot=file-item-skeleton]]:h-1.5 [&_[data-slot=file-item-clear]]:size-4 [&_[data-slot=file-item-clear-icon]]:size-3',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
